import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, throwError } from "rxjs";
import { UserModelInterfaces } from "../../interfaces/responses/user-model.interfaces";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { LoginRequestData } from "../../interfaces/requests/login-request-data";
import { ChangePasswordRequest } from "../../interfaces/requests/change-password.interfaces";


const env = environment;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private http = inject(HttpClient);

  private authState = new BehaviorSubject<UserModelInterfaces>({
    accessToken: '',
    exp: '',
    firstLogin: false,
    user: {
      id: '',
      firstName: '',
      lastName: '',
      email: '',
      roles: []
    },
  });


  loginPost(body: LoginRequestData): Observable<UserModelInterfaces> {
    const url = `${env.apiUrl}/auth/login`;
    return this.http.post<UserModelInterfaces>(
      url,
      body,
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }).pipe(
        catchError((error) => {
          return throwError(() => new Error(`Error logging in ${error}`));
        })
      );
  }

  authState$ = this.authState.asObservable();

  setAuthState(user: UserModelInterfaces): void {
    this.authState.next(user);
  }
  // Helper methods
  getAuthToken(): string | null {
    return this.authState.value.accessToken ||
      (typeof window !== 'undefined' ? localStorage.getItem('tokenn') : null);
  }

  changePassword(body: ChangePasswordRequest): Observable<any> {
    let token: string | null = null;
    if (typeof window !== 'undefined') {
      token = localStorage.getItem('tokenn');
    }
    const url = `${env.apiUrl}/auth/change-password`;
    return this.http.post<any>(url, body, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error changing password: ${error}`));
      })
    );
  }

  sendForgotPasswordCode(email: string): Observable<{ message: string; key: string }> {
    const url = `${env.apiUrl}/auth/forgot-password`;
    return this.http.post<{ message: string; key: string }>(url, { email }, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error sending verification code: ${error}`));
      })
    );
  }

  logout(): Observable<{ message: string }> {
    const url = `${env.apiUrl}/auth/logout`;
    return this.http.post<{ message: string }>(url, {}).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error logging out: ${error}`));
      })
    );
  }

  resetPassword(key: string, code: string, password: string, passwordConfirmation: string): Observable<any> {
    const url = `${env.apiUrl}/auth/reset-password`;
    return this.http.post<any>(url, {
      key,
      code,
      password,
      passwordConfirmation
    }, {
      headers: {
        'Content-Type': 'application/json',
      }
    }).pipe(
      catchError((error) => {
        return throwError(() => new Error(`Error resetting password: ${error}`));
      })
    );
  }

}
